export default __webpack_public_path__ + "static/media/MoreOptions.2d26aa42.svg";